/*
 * @Author: yyl
 * @Date: 2021-07-21 13:59:34
 * @LastEditTime: 2021-08-10 14:58:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \energy-internet-web\src\utils\aiRequest.js
 */
import axios from "axios";
import { ElMessageBox, ElMessage } from "element-plus";
import store from "@/store";
import { getToken, getTenantId, getRefreshToken } from "./auth.js";
import { setRequestUrl, setRequestBody } from "./setHeader";
const whiteList = ["/wechatGroup/deleteByids", "/information/deleteByids"];
const REFRESH_TOKEN_URL = "/api/v1/auth/refresh";

const handleRefreshTokenExpired = () => {
  ElMessage.closeAll();
  ElMessageBox.close();
  ElMessageBox.confirm(
    "登录状态已过期，您可以继续留在该页面，或者重新登录",
    "系统提示",
    {
      confirmButtonText: "重新登录",
      cancelButtonText: "取消",
      type: "warning",
    }
  ).then(() => {
    store.dispatch("common/LogOut").then(() => {
      location.reload();
    });
  });
};

export let axiosTemplate = (baseURL) => {
  axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
  // 创建axios实例
  const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL,
    // 超时
    timeout: 1000 * 60 * 2,
  });
  // request拦截器
  service.interceptors.request.use(
    (config) => {
      const timestamp = new Date().getTime();
      config.headers["Timestamp"] = timestamp;
      if (getToken()) {
        config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers["Target-Tenant-Id"] = getTenantId(); //获取租户id
        // if (config.method === 'post') {
        //   const temp = setRequestBody(config)
        //   config.headers['signature'] = temp.signature
        //   config.headers['timestamp'] = temp.timestamp
        //   config.headers['nonce'] = temp.nonce
        // } else {
        //   const temp = setRequestUrl(config)
        //   config.headers['signature'] = temp.signature
        //   config.headers['timestamp'] = temp.timestamp
        //   config.headers['nonce'] = temp.nonce
        // }
      }
      // if(!whiteList.includes(config.url)&&((config.method==='post'&&sessionStorage.getItem('currentName')&&sessionStorage.getItem('currentDept'))||sessionStorage.getItem('isAdmin'))){
      //   if(sessionStorage.getItem('isAdmin')){
      //     config.data={...config.data,...{
      //       currentName:sessionStorage.getItem('currentName'),
      //       currentDept:sessionStorage.getItem('currentDept'),
      //       isAdmin:'1'
      //     }}
      //   }else{
      //     config.data={...config.data,...{
      //       currentName:sessionStorage.getItem('currentName'),
      //       currentDept:sessionStorage.getItem('currentDept'),
      //       isAdmin:''
      //     }}
      //   }
      // }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
  // 是否正在刷新的标记
  let isRefreshing = false;
  // 重试队列，每一项将是一个待执行的函数形式
  let requests = [];

  const retryQueuedRequests = (error) => {
    requests.forEach(({ resolve, reject, config }) => {
      if (error) {
        reject(error);
        return;
      }
      resolve(service(config));
    });
    requests = [];
  };

  const tryRefreshAndReplay = async (config) => {
    if (!config || config.url === REFRESH_TOKEN_URL) {
      handleRefreshTokenExpired();
      return Promise.reject(new Error("refresh token 已失效"));
    }

    if (!getRefreshToken()) {
      handleRefreshTokenExpired();
      return Promise.reject(new Error("refresh token 不存在"));
    }

    if (!isRefreshing) {
      isRefreshing = true;
      try {
        ElMessage.closeAll();
        await store.dispatch("common/refreshToken");
        retryQueuedRequests();
        return service(config);
      } catch (e) {
        retryQueuedRequests(e);
        await store.dispatch("common/LogOut");
        location.reload();
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }

    return new Promise((resolve, reject) => {
      requests.push({ resolve, reject, config });
    });
  };

  // 响应拦截器
  service.interceptors.response.use(
    (res) => {
      const code = res.data.code;
      // 判断是否有code存在，兼容导出时返回整个文件流
      if (code) {
        if (code === "A0230") {
          return tryRefreshAndReplay(res.config);
        }
        if (code === "A0232") {
          handleRefreshTokenExpired();
          return Promise.reject(new Error("refresh token 无效或已过期"));
        }
        if (code != 1000 && code != 0) {
          // 手动操作由调用方统一展示异常，避免轮询重试时重复弹出消息。
          if (res.config?.silentError) {
            return Promise.reject(new Error(res.data.message || res.data.msg ||
              (typeof res.data.data === 'string' ? res.data.data : '') || '系统异常，请稍后重试'));
          }
          if (code == 1001) {
            ElMessage.closeAll();
            ElMessage({
              type: "warning",
              showClose: true,
              message: res.data.message,
            });

            return Promise.reject(res.data.message);
          } else if (code == 1002) {
            ElMessage.closeAll();
            return res.data;
          } else {
            if (code != "A0232" && code != "A0230") {
              ElMessage.closeAll();
              ElMessage({
                message:
                  res.data.data ||
                  res.data.message ||
                  res.data.msg ||
                  "系统异常，请稍后重试",
                type: "error",
                duration: 3 * 1000,
              });
            }
          }
          return Promise.reject("error");
        } else {
          return res.data;
        }
      } else {
        // code不存在时返回后端return对象
        return res;
      }
    },
    async (error) => {
      const responseData = error.response && error.response.data ? error.response.data : {};
      const { msg, code } = responseData;
      const { config } = error;
      if (code === "A0230") {
        return tryRefreshAndReplay(config);
      }
      if (code === "A0232") {
        handleRefreshTokenExpired();
        return Promise.reject(error);
      } else {
        if (config?.silentError) {
          return Promise.reject(new Error(msg || responseData.message || error.message || '网络请求失败'));
        }
        console.log("err1111", error);
        if (code != "A0232" && code != "A0230") {
          ElMessage.closeAll();
          ElMessage({
            message: msg,
            type: "error",
            duration: 5 * 1000,
          });
        }
        return Promise.reject(error.message);
      }
    }
  );

  return service;
};
